import React, { Component } from 'react'
import { connect } from 'react-redux'
import Submenu from '../Partidos/Components/SubmenuFases'
import GroupTitle from './Components/GroupTitle'
import StandingsTable from './Components/StandingsTable'
import Legend from './Components/Legend'
import ScrollIndicator from './Components/ScrollIndicator'
import Device from '../../../devices/device'
import './_styles.scss'
import { getNodeCode, getTabsSecondLevel, sendMetricScroll, sendMetricSelectContent } from '../utils'
import { positionTabs, viewRanking, viewStageGroup } from './constants'
import Utils from '../../../utils/Utils'
import getCurrentStageCode from '../services/getCurrentStageCode'
import { FASE_DE_GRUPOS_2, FASES_DE_GRUPOS, MAIN_MENU } from '../constants'
import { getStandings } from '../services/getStandings'
import { pushNavHistory, restoreComplete } from '../store/actions'
import Translator from '../../../requests/apa/Translator'

/**
 * TablaDePosiciones
 * Container — Standings table for Mundial 2026 (Fase de grupos).
 * Manages group selection state. Keyboard navigation (← →) is handled
 * internally by the Submenu component via onNavigate.
 */
class TablaDePosiciones extends Component {
  constructor (props) {
    super(props)
    this.state = {
      groupTabs: [],
      standingsData: [],
      rankingData: [],
      tableHeaders: [],
      activeGroup: null,
      activeFase: null,
      rankingScrollTop: 0,
      rankingMaxScroll: 0,
      loading: true
    }
    this.groupsRef = null
    this.rankingScrollRef = null
    this.fasesNavRef = null
    this.groupTabsNavRef = null
    this.keys = Device.getDevice().getKeys(),
    this.scrollMilestonesSent = new Set()

    this.tabsSeconLevel = getTabsSecondLevel(positionTabs)

    const code = getNodeCode()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
    this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
  }

  async componentDidMount () {
    const { tabsSeconLevel } = this
    const { pendingRestore, sectionId } = this.props
    const restoreEntry = pendingRestore && pendingRestore.section === sectionId ? pendingRestore : null
    const currentStage = await this.getCurrentStage()
    const activeFase = (currentStage === FASES_DE_GRUPOS || currentStage === FASE_DE_GRUPOS_2) ? tabsSeconLevel[0].id : tabsSeconLevel[1].id

    const view = (currentStage === FASES_DE_GRUPOS || currentStage === FASE_DE_GRUPOS_2) ? viewStageGroup : viewRanking

    const { groups: groupTabs, standingsData, headersTable: tableHeaders, rankingData } = await getStandings(this.idLeague, view)
    const activeGroup = groupTabs.length ? groupTabs[0].id : null

    if (restoreEntry) {
      this.setState({ groupTabs, standingsData, tableHeaders, rankingData }, () => {
        this.applyRestore(restoreEntry)
      })
    } else {
      
      this.setState({ groupTabs, activeGroup, activeFase, tableHeaders, standingsData, rankingData, loading: false })

      // Métricas
      const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
      const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
      const parentTabLabel = Translator.get(activeFase)
      const childTabData = groupTabs.find(group => group.id === activeGroup)
      const childTabLabel = groupTabs[0].id === activeFase ? childTabData && childTabData.label : null
      sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
    }
  }

  getCurrentStage = async () => {
      const { idLeague } = this
      return await getCurrentStageCode(idLeague)
  }

  componentWillUnmount () {
    if (this.props.pendingRestore) return
    const { activeGroup, activeFase } = this.state
    this.props.pushNavHistory({
      section: this.props.sectionId,
      activeGroup,
      activeFase
    })
  }

  applyRestore = (entry) => {
    const { tabsSeconLevel } = this
    const activeFase = entry.activeFase || tabsSeconLevel[0].id
    const activeGroup = entry.activeGroup || null
    const isFaseGrupos = activeFase === tabsSeconLevel[0].id
    this.setState({ activeFase, activeGroup, loading: false }, () => {
      setTimeout(() => {
        if (isFaseGrupos && this.groupTabsNavRef) {
          const btn = this.groupTabsNavRef.querySelector('.focusable')
          if (btn) btn.focus()
        } else {
          const btn = this.fasesNavRef && this.fasesNavRef.querySelector('.focusable')
          if (btn) btn.focus()
        }
      }, 0)
    })
    this.props.restoreComplete()
  }

  componentDidUpdate (prevProps, prevState) {
    const { pendingRestore, sectionId } = this.props
    if (pendingRestore && pendingRestore !== prevProps.pendingRestore && pendingRestore.section === sectionId) {
      this.applyRestore(pendingRestore)
    }
    if (prevState.activeGroup !== this.state.activeGroup && this.groupsRef) {
      var el = document.getElementById('group-table-' + this.state.activeGroup)
      if (el) this.groupsRef.scrollTop = el.offsetTop - this.groupsRef.offsetTop
    }
  }

  navigateFase = async (steps) => {
    this.setState({ loading: true })
    const { activeFase, activeGroup } = this.state
    const { tabsSeconLevel } = this
    const idx = tabsSeconLevel.findIndex((f) => f.id === activeFase)
    const newIdx = Math.max(0, Math.min(tabsSeconLevel.length - 1, idx + steps))
    if (newIdx === idx) return
    this.props.pushNavHistory({ section: this.props.sectionId, activeFase, activeGroup })
    
    const { groups: groupTabs, standingsData, headersTable: tableHeaders, rankingData } = await getStandings(this.idLeague, tabsSeconLevel[newIdx].id)
    this.scrollMilestonesSent = new Set()
    this.setState({ activeFase: tabsSeconLevel[newIdx].id, loading: false, groupTabs, standingsData, tableHeaders, rankingData, rankingScrollTop: 0, rankingMaxScroll: 0 })

    // Métricas
    const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
    const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
    const parentTabData = tabsSeconLevel[newIdx]
    const parentTabLabel = parentTabData && parentTabData.label
    const childTabData = newIdx < 1 ? this.state.groupTabs.find(tab => tab.id === activeGroup) || null : null
    const childTabLabel = childTabData && childTabData.label
    sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
  }

  navigateGroup = (steps) => {
    const { groupTabs, activeGroup, activeFase } = this.state
    if (!groupTabs.length) return
    const idx = groupTabs.findIndex((g) => g.id === activeGroup)
    const newIdx = Math.max(0, Math.min(groupTabs.length - 1, idx + steps))
    if (newIdx === idx) return
    this.props.pushNavHistory({ section: this.props.sectionId, activeFase, activeGroup })
    this.setState({ activeGroup: groupTabs[newIdx].id })

    // Métricas
    const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
    const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
    const parentTabLabel = Translator.get(activeFase)
    const childTabData = groupTabs[newIdx]
    const childTabLabel = childTabData && childTabData.label
    sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
  }

  handleRankingKeyDown = (e) => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (!currentKey) return

    const el = this.rankingScrollRef
    const firstRow = el ? el.querySelector('.standings-table__row') : null
    const actualRowPx = firstRow ? firstRow.offsetHeight : 58
    const STEP = actualRowPx * 4
    const MAX_SCROLL = el ? el.scrollHeight - el.clientHeight : 0
    var next = this.state.rankingScrollTop

    if (currentKey === 'UP') {
      e.preventDefault()
      e.stopPropagation()
      if (this.state.rankingScrollTop === 0) {
        var tab = document.querySelector('.submenu__tab.tabs-vista.item-vista-not-focused, .submenu__tab.tabs-vista.item-vista-focused')
        if (tab) tab.focus()
        return
      }
      next = Math.max(0, next - STEP)
    } else if (currentKey === 'DOWN') {
      if (this.state.rankingScrollTop >= MAX_SCROLL) return
      e.preventDefault()
      e.stopPropagation()
      next = Math.min(MAX_SCROLL, next + STEP)
    } else {
      return
    }

    this.setState({ rankingScrollTop: next, rankingMaxScroll: MAX_SCROLL })
    if (this.rankingScrollRef) this.rankingScrollRef.scrollTop = next

    const prevPercent = MAX_SCROLL > 0 ? Math.round(this.state.rankingScrollTop / MAX_SCROLL * 100) : 0
    const nextPercent = MAX_SCROLL > 0 ? Math.round(next / MAX_SCROLL * 100) : 0

    const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
    const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
    const parentTabLabel = this.tabsSeconLevel[1].label

    if (currentKey === 'DOWN') {
      const MILESTONES = [25, 50, 75]
      MILESTONES.forEach(m => {
        if (prevPercent < m && m <= nextPercent && !this.scrollMilestonesSent.has(m)) {
          this.scrollMilestonesSent.add(m)
          sendMetricScroll(mainMenuLabel, parentTabLabel, null, m)
        }
      })
      if (next >= MAX_SCROLL && !this.scrollMilestonesSent.has(100)) {
        this.scrollMilestonesSent.add(100)
        sendMetricScroll(mainMenuLabel, parentTabLabel, null, 100)
      }
    } else {
      if (prevPercent === 100 && nextPercent < 100) {
        this.scrollMilestonesSent.delete(100)
      }
      const MILESTONES = [25, 50, 75]
      MILESTONES.forEach(m => {
        if (nextPercent < m && m <= prevPercent && this.scrollMilestonesSent.has(m)) {
          this.scrollMilestonesSent.delete(m)
          sendMetricScroll(mainMenuLabel, parentTabLabel, null, m)
        }
      })
    }
  }

  handleDownFaseTabs = (e) => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey !== 'DOWN') return

    e.preventDefault()
    e.stopPropagation()

    window.SpatialNavigation.focus('.tabla-de-posiciones-container .focusable')

  }

  render () {
    const { tabsSeconLevel } = this

    const { groupTabs, activeGroup, activeFase, rankingScrollTop, rankingMaxScroll, tableHeaders, standingsData, rankingData, loading } = this.state
    const isFaseGrupos = activeFase === tabsSeconLevel[0].id
    const rankingScrollRatio = rankingMaxScroll > 0 ? rankingScrollTop / rankingMaxScroll : 0
    const { headerHidden } = this.props

    const leftItems = [
      { key: 'pts',   label: Utils.cutPlayerString('PTS', 5),   description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_puntos'), 30) },
      { key: 'ptd', label: Utils.cutPlayerString('PTD', 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_partidosdisputados'), 30) },
      { key: 'g',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_goles'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_goles'), 30) },
      { key: 'e', label: Utils.cutPlayerString('E', 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_empatados'), 30) }
    ]
    const rightItems = [
      { key: 'p',  label: Utils.cutPlayerString('P', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_perdidos'), 30) },
      { key: 'gf',  label: Utils.cutPlayerString('GF', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_golesafavor'), 30) },
      { key: 'gc',  label: Utils.cutPlayerString('GC', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_golesencontra'), 30) },
      { key: 'gd',  label: Utils.cutPlayerString('GD', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_diferenciadegoles'), 30) }
    ]

    if(loading) return null

    return (
      <div className='tabla-de-posiciones__content'>
        <div ref={(el) => { this.fasesNavRef = el }} onKeyDown={this.handleDownFaseTabs}>
          <Submenu
            tabs={tabsSeconLevel}
            activeTab={activeFase}
            onNavigate={this.navigateFase}
            classNames={{
              tab: 'tabs-vista',
              active: 'item-vista-not-focused',
            }}
          />
        </div>
        {isFaseGrupos && (
          <div className='tabla-de-posiciones tabla-de-posiciones-container'>
            <div
              className='tabla-de-posiciones__submenu-fases'
              ref={(el) => { this.groupTabsNavRef = el }}
              onKeyDown={(e) => {
                const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
                if (currentKey === 'UP') {
                  e.preventDefault()
                  e.stopPropagation()
                  e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
                  var btn = this.fasesNavRef && this.fasesNavRef.querySelector('.focusable')
                  if (btn) btn.focus()
                }
              }}
            >
              <Submenu
                tabs={groupTabs}
                activeTab={activeGroup}
                onNavigate={this.navigateGroup}
                getActiveLabel={(tab) => {
                  const group = standingsData.find((g) => g.id === tab.id)
                  return Utils.cutPlayerString(group ? group.label : tab.label, 8, undefined, '')
                }}
                classNames={{
                  tab: 'tabs-phases',
                  active: 'item-active-not-focused',
                }}
                enableKeyboardNavigation={true}
              />
            </div>
            <div
              className='tabla-de-posiciones__groups-scroll'
              ref={(el) => { this.groupsRef = el }}
              style={{ height: activeGroup === 'L' ? '38.7rem' : '40rem' }}
            >
              {standingsData.map((group) => (
                <div key={group.id} id={'group-table-' + group.id} className='tabla-de-posiciones__group'>
                  <GroupTitle label={group.label} />
                  <StandingsTable headers={tableHeaders} rows={group.teams} />
                </div>
              ))}
              <Legend leftItems={leftItems} rightItems={rightItems} headerHidden={headerHidden}/>
            </div>
          </div>
        )}
        {!isFaseGrupos && (
          <div className='tabla-de-posiciones__ranking-wrapper tabla-de-posiciones-container'>
            <div className='tabla-de-posiciones'>
              <p className='group-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_tablaposiciones_fasegrupos_texto_titulo_ranking'), 34)}</p>
              <StandingsTable
                rows={rankingData}
                bodyClassName={headerHidden ? 'tabla-de-posiciones__ranking-scroll tabla-de-posiciones__ranking-scroll--brandheader-hidden' : 'tabla-de-posiciones__ranking-scroll tabla-de-posiciones__ranking-scroll--brandheader-visible'}
                bodyRef={(el) => { this.rankingScrollRef = el; if (el) el.scrollTop = this.state.rankingScrollTop }}
                headers={tableHeaders}
                footer={<Legend leftItems={leftItems} rightItems={rightItems} headerHidden={headerHidden} />}
              />
            </div>
            <ScrollIndicator
              onKeyDown={this.handleRankingKeyDown}
              scrollRatio={rankingScrollRatio}
              className='ranking-scrollbar'
              trackHeightRem={34.67}
              thumbHeightRem={11.4}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  pendingRestore: state.pendingRestore,
  headerHidden: state.headerHidden,
})

const mapDispatchToProps = (dispatch) => ({
  pushNavHistory: (entry) => dispatch(pushNavHistory(entry)),
  restoreComplete: () => dispatch(restoreComplete())
})

export default connect(mapStateToProps, mapDispatchToProps)(TablaDePosiciones)



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/index.jsx